// Az űrlap állapota az URL-ben, hogy a link megosztható legyen.
// Csak az alapértéktől eltérő mezők kerülnek bele.

export const DEFAULT_FORM = {
  income: '6',
  expense: '0',
  unit: 'MFt',
  koltseghanyad: 0.5,
  ipaKulcs: 2,
  allastipus: 'foallasu',
  garantalt: false,
  monthly: false,
  szjaMentes: false,
  cegesJovedelem: false,
};

// választható iparűzési adó mértékek %-ban: 1,0 … 2,0
export const IPA_KULCSOK = Array.from({ length: 11 }, (_, i) => (10 + i) / 10);

const isAmount = (v) => /^\d+(\.\d+)?$/.test(v);
const oneOf = (values) => (v) => values.includes(v);
const bool = { parse: (v) => v === '1', format: (v) => (v ? '1' : null) };

// mező -> URL paraméter, olvasás, írás
const FIELDS = {
  income: { param: 'bevetel', valid: isAmount },
  expense: { param: 'koltseg', valid: isAmount },
  unit: { param: 'egyseg', valid: oneOf(['Ft', 'eFt', 'MFt']) },
  koltseghanyad: {
    param: 'kh',
    valid: oneOf(['50', '80', '90']),
    parse: (v) => Number(v) / 100,
    format: (v) => String(Math.round(v * 100)),
  },
  ipaKulcs: {
    param: 'ipa',
    valid: oneOf(IPA_KULCSOK.map(String)),
    parse: Number,
    format: String,
  },
  allastipus: {
    param: 'allas',
    valid: oneOf(['foallasu', 'mellekallasu', 'nyugdijas']),
  },
  garantalt: { param: 'garantalt', ...bool },
  monthly: { param: 'havi', ...bool },
  szjaMentes: { param: '25alatt', ...bool },
  cegesJovedelem: { param: 'ceges', ...bool },
};

// egyéni minimálbér / bérminimum, Ft-ban
const SETTINGS_PARAMS = { minimalber: 'minimalber', berminimum: 'berminimum' };

const search = () => {
  try {
    return new URLSearchParams(window.location.search);
  } catch {
    return new URLSearchParams();
  }
};

export const readForm = () => {
  const params = search();
  const form = { ...DEFAULT_FORM };
  Object.entries(FIELDS).forEach(([key, { param, valid, parse }]) => {
    const v = params.get(param);
    if (v === null || (valid && !valid(v))) return;
    form[key] = parse ? parse(v) : v;
  });
  return form;
};

export const readSettings = () => {
  const params = search();
  const settings = {};
  Object.entries(SETTINGS_PARAMS).forEach(([key, param]) => {
    const v = params.get(param);
    if (v !== null && /^\d{1,7}$/.test(v) && Number(v) > 0) {
      settings[key] = Number(v) / 1000;
    }
  });
  return settings;
};

export const writeUrl = (form, settings, defaultSettings) => {
  const params = new URLSearchParams();
  Object.entries(FIELDS).forEach(([key, { param, format }]) => {
    if (form[key] === DEFAULT_FORM[key]) return;
    const v = format ? format(form[key]) : String(form[key]);
    if (v !== null) params.set(param, v);
  });
  Object.entries(SETTINGS_PARAMS).forEach(([key, param]) => {
    if (settings[key] !== defaultSettings[key]) {
      params.set(param, String(Math.round(settings[key] * 1000)));
    }
  });
  const query = params.toString();
  const url = `${window.location.pathname}${query ? `?${query}` : ''}${
    window.location.hash
  }`;
  try {
    window.history.replaceState(null, '', url);
  } catch {}
};
